// Match the RCTI editor pricing basis without changing stored document totals.
export function rctiLineTax(item, gstType = "Inclusive") {
  const rate = gstType === "No GST" ? 0 : Number(item.gst || 0);
  const net =
    Math.round(
      (Math.max(
        0,
        Math.round(
          Number(item.itemPrice || 0) * Number(item.itemQuantity || 0) * 100
        ) /
          100 -
          Number(item.discountAmount || 0)
      ) +
        Number.EPSILON) *
        100
    ) / 100;
  const amount =
    gstType === "Exclusive" ? (net * rate) / 100 : (net * rate) / (100 + rate);
  return {
    taxable: rate > 0,
    rate,
    amount: Math.round((amount + Number.EPSILON) * 100) / 100,
  };
}
